<template>
    <div class="login-wrap">
        <div class="ms-title">iHomework Management</div>
        <div class="ms-login" v-show="showPanel == 'login'">
            <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="demo-ruleForm">
                <el-form-item prop="username">
                    <el-input v-model="loginForm.email" placeholder="email"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" placeholder="password" v-model="loginForm.password"></el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button :loading="loading" type="primary" @click="login('loginForm')">Login</el-button>
                </div>
                <div class="other-btn">
                    <el-button type="text" @click="showPanel = 'reset'">Forget Password</el-button>
                </div>
                <p style="font-size:12px;line-height:30px;color:#999;"></p>
            </el-form>
        </div>
        <div v-show="showPanel == 'reset'" class="ms-login" style="height:328px">
            <el-form :model="resetPasswordForm" :rules="resetPasswordFormRules" ref="resetPasswordForm" label-width="0px" class="demo-ruleForm">
                <el-form-item prop="email">
                    <el-input v-model="resetPasswordForm.email" placeholder="email"></el-input>
                </el-form-item>
                <el-form-item prop="reset_password_token">
                    <el-input v-model="resetPasswordForm.reset_password_token" placeholder="email token"></el-input>
                    <el-button style="position: absolute; right: 6px; top: 50%; transform: translateY(-50%);" type="success" size="mini" :disabled="email_cd > 0" @click="sendResetEmail">{{email_cd > 0 ? email_cd : 'send token'}}</el-button>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" placeholder="New Password" v-model="resetPasswordForm.password"></el-input>
                </el-form-item>
                <el-form-item prop="password_confirmation">
                    <el-input type="password" placeholder="Confirm Password" v-model="resetPasswordForm.password_confirmation"></el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="reset()">Reset Password</el-button>
                </div>
                <div class="other-btn">
                    <el-button type="text" @click="showPanel = 'login'">Login</el-button>
                </div>
                <p style="font-size:12px;line-height:30px;color:#999;"></p>
            </el-form>
        </div>
    </div>
</template>

<script>
import * as Cookies from 'tiny-cookie'

export default {
  data: function () {
    return {
      email_cd: 0,
      showPanel: 'login',
      loading: false,
      loginForm: {
        provider: 'email',
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, type: 'email', message: 'Please enter the correct email', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please enter the password', trigger: 'blur' }
        ]
      },
      resetPasswordForm: {
        email: '',
        reset_password_token: '',
        password: '',
        password_confirmation: ''
      },
      resetPasswordFormRules: {
        email: [
          { required: true, type: 'email', message: 'Please enter the correct email', trigger: 'blur' }
        ],
        reset_password_token: [
          { required: true, message: 'token is empty', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'password is empty', trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true, message: 'password Confirmation is empty', trigger: 'blur' }
        ]
      }
    }
  },
  created () {

  },
  methods: {
    login () {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$api.users.login(this.loginForm).then(res => {
            this.loading = false
            Cookies.set('access_token', res.access_token, { expires: new Date(res.expiry * 1000) })
            this.$router.push(this.$route.query.redirect || '/index')
          }).catch(err => {
            this.$error(err)
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sendResetEmail () {
      if (this.email_cd > 0) {
        return
      }
      this.$api.users.password_reset_request(this.resetPasswordForm.email).then(data => {
        this.$success('Email has been sent, please pay attention to your inbox')
        this.email_cd = 60
        let timer = setInterval(() => {
          this.email_cd--
          if (this.email_cd == 0) {
            clearInterval(timer)
          }
        }, 1000)
      }).catch(err => {
        this.$error('Email send failure')
      })
    },
    reset () {
      this.$refs['resetPasswordForm'].validate((valid) => {
        if (valid) {
          this.$api.users.password(this.resetPasswordForm).then(res => {
            console.log(res)
            this.$message({
              type: 'success',
              message: 'Reset Password Success!'
            })
            this.showPanel = true
          }).catch(err => {
            console.log(err)
            this.$error(err)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
    .login-wrap{
        position: relative;
        width:100%;
        height:100%;
        background: linear-gradient(135deg, #6ff5ff 0, #006eab 100%);
    }
    .ms-title{
        position: absolute;
        top:50%;
        width:100%;
        margin-top: -230px;
        text-align: center;
        font-size:30px;
        color: #fff;

    }
    .ms-login{
        position: absolute;
        left:50%;
        top:50%;
        width:300px;
        height:200px;
        margin:-150px 0 0 -190px;
        padding:40px;
        border-radius: 5px;
        background: #fff;
    }
    .login-btn{
        text-align: center;
    }
    .login-btn button{
        width:100%;
        height:36px;
    }
    .other-btn{
        display: flex;
        justify-content: space-between;
    }

    img{
        height:100%;
    }
</style>
